import {JSONSchema7} from "json-schema";

const ForwardStepsLocationsSchema = async () => {
    let schema: JSONSchema7 = {
        title: "EditedBySimpleTextSchema",
        type: "object",
        //
        definitions: {}
    };
    //
    schema = {
        properties: {
            className: {
                type: "string",
            }
        },
        //
        ...schema
    }
    //
    return schema;
}

export default ForwardStepsLocationsSchema;